const routesConstants = {
  AUTHENTICATION_PAGE: "login",
  KPI: "kpi",
  PULSE: "pulse",
  PULSE_PROJECT: "pulse/projects/:id",
  PULSE_PORTAL: "pulse/portals/:id",
  PULSE_REPORTS: "pulse/reports",
  PULSE_ADMIN: "pulse/admin",
};

export default routesConstants;
